import _ from 'lodash';
import template from './groupsTreeRoot.html';

export default {
  name: 'groupsTreeRoot',
  template,
  controller: GroupsTreeRootController,
  bindings: {
    groups: '<',
    selectedGroups: '<',
    show: '<?',
    options: '<?',
    selectedGroupsUpdated: '&?',
  }
};

/* @ngInject */
function GroupsTreeRootController($scope, GroupsButtonService) {
  const vm = this;

  const cache = GroupsButtonService.cache;

  vm.$onInit = $onInit;
  vm.$onChanges = $onChanges;
  vm.$postLink = $postLink;

  vm.selectGroup = selectGroup;
  vm.removeGroup = removeGroup;
  vm.isGroupInSelectedTree = isGroupInSelectedTree;

  function $onInit() {

    // Needed for the case when using two instances of this component in the same page
    GroupsButtonService.cleanCache();

    vm.editGroups = { editState: false, groupTree: cache.groupTree };
    vm.selectedGroupsTree = cache.selectedGroupsTree;

    if (!_.isEmpty(vm.groups)) {
      // Often this will be uninitialized until the parent component's own $onInit is done fetching
      vm.editGroups.groupTree = vm.groups;
      GroupsButtonService.flattenTheGroupsIntoReferralObj(vm.groups);

      buildSelectedTrees(vm.selectedGroups);
    }
  }

  function $onChanges({ groups, selectedGroups }) {
    if (groups?.isFirstChange() || selectedGroups?.isFirstChange()) {
      return; // $onInit hasn't run yet
    }

    if (groups?.currentValue) {
      vm.editGroups.groupTree = groups.currentValue;
      const root = cache.selectedGroupsTree[0];
      if (root) {
        removeGroup(root);
      }
      GroupsButtonService.flattenTheGroupsIntoReferralObj(groups.currentValue);
    }

    buildSelectedTrees(selectedGroups?.currentValue || vm.selectedGroups);
  }


  function $postLink() {
    $scope.$watch(() => cache.editState, () => {
      vm.editGroups.editState = cache.editState;
    });
  }

  function buildSelectedTrees(selected = []) {
    _.forEach(selected, ({ id }) => {
      const grp = cache.groupsRef[id];
      if (!grp) {
        // Group may not exist in `groupsRef` if from an org-group outside users authorization
        return;
      }
      vm.options?.multiChildSelection ?
        GroupsButtonService.buildSelectedTreeWithChilds(grp, grp) :
        GroupsButtonService.buildSelectedTree(grp);
    });
  }

  function selectGroup(grp) {
    GroupsButtonService.selectUnseenGroup(grp, vm.options?.multiChildSelection);
    if (vm.selectedGroupsUpdated) {
      vm.selectedGroupsUpdated(grp);
    }
  }

  function removeGroup(grp) {
    GroupsButtonService.resetCount(grp);
    GroupsButtonService.removeGroupFromTree(grp);
    if (vm.selectedGroupsUpdated) {
      vm.selectedGroupsUpdated(grp);
    }
  }

  function isGroupInSelectedTree(groupId) {
    return _.includes(_.map(vm.selectedGroupsTree, 'id'), groupId);
  }
}
